const questionMixin = {
    data() {
        return {};
    },

    methods: {
        getUnlinkedQuestion() {
            if (localStorage.getItem('unlinked_rate')) {
                return {
                    id: localStorage.getItem('unlinked_rate'),
                    value: localStorage.getItem('unlinked_rate_question'),
                    location: localStorage.getItem('unlinked_rate_question_location') || ''
                }
            } else {
                return null
            }
        }
    }
};

export default questionMixin;
